import { c as _c } from "react/compiler-runtime";
import PopupComponent, { PopupContext, PopupType } from '@spa/components/popup/popup.component';
import { ReactElement, memo } from 'react';
import { StateCart, StateCartEntry } from '@spa/lib/store/carts/CartsState';
import { checkoutLoginPath, checkoutStepsStartPath } from '@spa/lib/const';
import { ButtonType } from '@spa/components/button/types/ButtonType';
import LinkButtonComponent from '@spa/components/button/link-button/link-button.component';
import { LinkTarget } from '@spa/lib/react/hooks/useLinkAttributes';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import classNames from 'clsx';
import { createPortal } from 'react-dom';
import getAuthSessionUserId from '@spa/lib/auth/getAuthSessionUserId';
import selectHomeDeliveryCart from '@spa/lib/store/carts/selectors/selectHomeDeliveryCart';
import styles from '@spa/components/add-to-cart/incompatible-cart-layer.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
import useNextAuthOrSession from '@spa/lib/react/hooks/useNextAuthOrSession';
import { useSelector } from 'react-redux';
export interface Props {
  readonly isOpen: boolean;
  readonly onClosed: () => void;
}
function IncompatibleCartLayerComponent(t0) {
  const $ = _c(37);
  const {
    isOpen,
    onClosed
  } = t0;
  const {
    formatMessage
  } = useNamespacedIntl("incompatible-cart-layer");
  const {
    authSession
  } = useNextAuthOrSession();
  const userId = getAuthSessionUserId(authSession);
  const homeDeliveryCart = useSelector(selectHomeDeliveryCart);
  let t1;
  if ($[0] !== homeDeliveryCart?.entries) {
    t1 = homeDeliveryCart?.entries.find(_temp);
    $[0] = homeDeliveryCart?.entries;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const preorderProductInCart = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classNames(styles["incompatible-cart-layer__title"], "bold");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== formatMessage || $[4] !== preorderProductInCart) {
    t3 = preorderProductInCart ? formatMessage("preOrderTitle") : formatMessage("title");
    $[3] = formatMessage;
    $[4] = preorderProductInCart;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <h1 className={t2}>{t3}</h1>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== formatMessage || $[9] !== preorderProductInCart) {
    t5 = preorderProductInCart ? formatMessage("preOrderDescription") : formatMessage("description");
    $[8] = formatMessage;
    $[9] = preorderProductInCart;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <p className={styles["incompatible-cart-layer__text"]}>{t5}</p>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== formatMessage) {
    t7 = formatMessage("toCart");
    $[13] = formatMessage;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      type: "internal",
      resolved: true,
      linkTitle: null,
      path: "/cart/",
      target: LinkTarget.SELF,
      linkParams: [],
      anchorTarget: null
    };
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7) {
    t9 = <LinkButtonComponent buttonType={ButtonType.TERTIARY} text={t7} link={t8} />;
    $[16] = t7;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = userId !== null ? checkoutStepsStartPath : checkoutLoginPath;
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = [];
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10) {
    t12 = {
      type: "internal",
      resolved: true,
      linkTitle: null,
      path: t10,
      target: LinkTarget.SELF,
      linkParams: t11,
      anchorTarget: null
    };
    $[19] = t10;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== formatMessage) {
    t13 = formatMessage("toCheckout");
    $[21] = formatMessage;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t12 || $[24] !== t13) {
    t14 = <LinkButtonComponent link={t12} buttonType={ButtonType.PRIMARY} text={t13} />;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t14 || $[27] !== t9) {
    t15 = <div className={styles["incompatible-cart-layer__buttons"]}>{t9}{t14}</div>;
    $[26] = t14;
    $[27] = t9;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t15 || $[30] !== t4 || $[31] !== t6) {
    t16 = <div className={styles["incompatible-cart-layer"]}>{t4}{t6}{t15}</div>;
    $[29] = t15;
    $[30] = t4;
    $[31] = t6;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== isOpen || $[34] !== onClosed || $[35] !== t16) {
    t17 = createPortal(<PopupComponent isOpen={isOpen} onClosed={onClosed} aria-live="assertive" popupType={PopupType.CENTER} popupContext={PopupContext.WITHOUT_TITLE}>{t16}</PopupComponent>, document.body);
    $[33] = isOpen;
    $[34] = onClosed;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  return t17;
}
function _temp(t0) {
  const {
    product: t1
  } = t0;
  const {
    preOrderSettings: entryPreOrderSettings
  } = t1;
  return !!entryPreOrderSettings && entryPreOrderSettings.isActive;
}
export default memo(IncompatibleCartLayerComponent);